import React, { useState } from 'react';
import { boiQuizQuestions } from './quizQuestions';
import Heading from '../../../../components/heading/Heading';
import styles from '../BoiQuiz.styles';
import { HEADING } from '../../../../components/heading/constants/constants';
import CircularProgressBar from '../../../../components/circularprogressbar/CircularProgressBar';
import Button from '../../../../components/button/Button';
import { BUTTON_TYPE } from '../../../../components/button/constants';
import Icons from '../../../../components/icons/Icons';
import { VEC_ICON_NAME } from '../../../../components/icons/constants';
import useTxNavigate from '../../../../../libs/txnavigate/TxNavigateHook';

const Quiz = () => {
  const [currentQuestion, setCurrentQuestion] = useState("Q1");
  const [finalResult, setFinalResult] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [questionsAnswered, setQuestionsAnswered] = useState(0);
  const [currentProgress, setCurrentProgress] = useState(0);

  const navigate = useTxNavigate();

  const handleOptionSelect = (optionKey) => {
    setSelectedOption(optionKey);
    calculateProgress();
  };

  const handleBack = () => {
    const prevQuestionKey = getPrevQuestionKey(currentQuestion);
    if (prevQuestionKey) {
      setCurrentQuestion(prevQuestionKey);
      setSelectedOption(null);
      setQuestionsAnswered(questionsAnswered - 1);
    }
  };

  const handleNext = () => {
    if (selectedOption !== null) {
      const nextQuestionKey = getNextQuestionKey(currentQuestion, selectedOption);
      if (nextQuestionKey && !["FinalResult1", "FinalResult2"].includes(nextQuestionKey)) {
        setCurrentQuestion(nextQuestionKey);
        setSelectedOption(null);
        setQuestionsAnswered(questionsAnswered + 1);
      } else {
        setFinalResult(boiQuizQuestions[boiQuizQuestions[currentQuestion].next[selectedOption]].result);
      }
    }
  };

  const getPrevQuestionKey = (currentQuestionKey) => {
    const questionKeys = Object.keys(boiQuizQuestions);
    const currentIndex = questionKeys.indexOf(currentQuestionKey);
    return currentIndex > 0 ? questionKeys[currentIndex - 1] : null;
  };

  const getNextQuestionKey = (currentQuestionKey, selectedOptionKey) => {
    const nextQuestionKey = boiQuizQuestions[currentQuestionKey]?.next[selectedOptionKey];
    return nextQuestionKey || null;
  };

  const calculateProgress = () => {
    let progress = 0;
    switch (currentQuestion) {
      case "Q1":
        progress = 33.33;
        break;
      case "Q2":
        progress = 66.67;
        break;
      case "Q3":
        progress = 66.67;
        break;
      case "Q4":
        progress = 66.67;
        break;
      case "Q5":
        progress = 66.67;
        break;
      default:
        progress = 0;
        break;
    }
  
    setCurrentProgress(progress);
  };

  const renderQuestion = () => {
    const currentQuestionData = boiQuizQuestions[currentQuestion];
    return (
      <div style={styles.quizContainer}>
        <div style={styles.quizQuestionContainer}>
          <Heading type={HEADING.H2} customStyle={styles.quizQuestionText} >{currentQuestionData.question} </Heading>
          <CircularProgressBar progress={currentProgress} />
        </div>
        <div style={styles.quizOptionsContainer}>
          {currentQuestionData.options.map(option => (
            <div key={option.key} style={{ ...styles.quizOptions, ...(selectedOption === option.key ? styles.selectedQuizOption : {}) }} onClick={() => handleOptionSelect(option.key)}>{option.text}</div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div>
      {finalResult !== null ? (
        <div style={styles.quizFinalResultContainer}>
          <Icons style={styles.quizFinalResultIconStyles} familyName={'vec'} iconName={VEC_ICON_NAME.BOI_QUIZ_COMPLETION_ICON} />
          <span>Based on your inputs</span>
          <Heading type={HEADING.H2}>
            {finalResult ? "You fulfil the criteria for a “Reporting Company”" : "Your company may not qualify as a “Reporting Company”"}
          </Heading>
          <div style={styles.quizFinalResultActionBtns}>
            {finalResult === false && <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => window.open("https://www.fincen.gov/sites/default/files/shared/BOI_FAQs_Q%26A_12.1.23.pdf", "_blank", "noopener,noreferrer")}>Click here to learn more</Button>}
            <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => navigate(`/boireporting/fileboi`)}>Click here to file</Button>
          </div>
          <div style={styles.noteDiv}>
            <span style={styles.noteDivStar}>*</span> Please note that the classification offered is solely for informational purposes. It is recommended to seek advice from a legal professional or contact FinCEN directly for further classification assistance.
          </div>
        </div>
      ) : (
        <div>
          {renderQuestion()}
          <div style={styles.navigationBtnsContainer}>
            <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={handleBack} disabled={!getPrevQuestionKey(currentQuestion)}>Back</Button>
            <Button type={BUTTON_TYPE.PRIMARY} onClickCb={handleNext} disabled={selectedOption === null}>Next</Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Quiz;
